import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-select-days',
  templateUrl: './select-days.component.html',
  styleUrls: ['./select-days.component.scss'],
})
export class SelectDaysComponent implements OnInit {
  @Input() selectedDays = [];
  options: any;
  selectAllDays: boolean = false;
  isforSurcharge: any;
  selectedSurchargeDays: any;
  lstDays: Array<any> = [
    { id: 1, day: 'Monday', isChecked: false },
    { id: 2, day: 'Tuesday', isChecked: false },
    { id: 3, day: 'Wednesday', isChecked: false },
    { id: 4, day: 'Thursday', isChecked: false },
    { id: 5, day: 'Friday', isChecked: false },
    { id: 6, day: 'Saturday', isChecked: false },
    { id: 7, day: 'Sunday', isChecked: false },
    { id: 8, day: 'Public Holidays', isChecked: false }
  ];
  filteredData: any = [];
  constructor(private modalCtrl: ModalController,
    private navParams: NavParams,
  ) {
    this.options = navParams.data.options;
    this.isforSurcharge = navParams.data.isFor;
    this.selectedDays = navParams.data.selectedDays;

    if(!!this.selectedDays){
      for (let i = 0; i < this.selectedDays.length; i++) {
        if (this.selectedDays[i].isChecked) {
          this.selectAllDays = this.selectedDays.every(el => el.isChecked === true);
        }
      }
    }

    // console.log(navParams.data.selectedSurchargeDays[0].applicableOn.dayIds);
    // console.log('this.isforSurcharge: ', this.isforSurcharge);
    // if (this.options && this.isforSurcharge === 'package') {
    //   if (this.lstDays.length === this.selectedDays.length) {
    //     for (let i = 0; i < this.lstDays.length; i++) {
    //       this.lstDays[i].isChecked = true;
    //     }
    //   }
    // else if (this.lstDays.length === this.selectedDays?.dayIds.length) {
    //   for (let i = 0; i < this.lstDays.length; i++) {
    //     this.lstDays[i].isChecked = true;
    //   }
    // }
    //   else {
    //     for (let index = 0; index < this.selectedDays?.dayIds.length; index++) {
    //       for (let i = 0; i < this.lstDays.length; i++) {
    //         if (this.selectedDays?.dayIds[index] === this.lstDays[i].id) {
    //           this.lstDays[i].isChecked = true;
    //           break;
    //         }
    //       }
    //     }
    //   }
    // }
    // else if (this.options && (this.isforSurcharge === 'surcharge' || this.isforSurcharge === 'stay' ||
    //   this.isforSurcharge === 'play')) {
    //   this.selectedSurchargeDays = navParams?.data?.selectedSurchargeDays[0]?.applicableOn?.dayIds;

    //   if (this.lstDays.length === this.selectedSurchargeDays?.length) {
    //     for (let i = 0; i < this.lstDays.length; i++) {
    //       this.lstDays[i].isChecked = true;
    //     }
    //   }
    //   else {
    //     for (let index = 0; index < this.selectedSurchargeDays?.length; index++) {
    //       for (let i = 0; i < this.lstDays.length; i++) {
    //         if (this.selectedSurchargeDays[index] === this.lstDays[i].id) {
    //           this.lstDays[i].isChecked = true;
    //           break;
    //         }
    //       }
    //     }
    //   }
    // }
    // console.log('lstDays-------------', this.lstDays);
  }
  ngOnInit() {
  }
  checkboxClick(event, id) {
    if (event.target.checked) {
      for (let index = 0; index < this.selectedDays.length; index++) {
        if (this.selectedDays[index].id === id) {
          if (event.target.checked) {
            this.selectedDays[index].isChecked = true;
            // console.log('this.lstDays: ', this.lstDays);
          }
          else {
            this.selectedDays[index].isChecked = false;
            // console.log('this.lstDays: ', this.lstDays);
          }
          break;
        }
        else {
          for (let index = 0; index < this.selectedDays.length; index++) {
            if (this.selectedDays[index].isChecked) {
              this.selectAllDays = this.selectedDays.every(el => el.isChecked === true);
            }
            else {
              // console.log('else');
            }
          }
        }
      }
    }

  }

  selectAll(event): void {
    if (event.target.checked) {
      for (let i = 0; i < this.selectedDays.length; i++) {
        this.selectedDays[i].isChecked = true;
      }
      this.selectAllDays = this.selectedDays.every(el => el.isChecked === true);

    }
    else {
      for (let i = 0; i < this.selectedDays.length; i++) {
        this.selectedDays[i].isChecked = false;
      }
      this.selectAllDays = this.selectedDays.every(el => el.isChecked === false);
    }
  }
  cancel() {
    this.modalCtrl.dismiss();
  }

  apply() {
    this.modalCtrl.dismiss({
      selectedDays: this.selectedDays
    });
  }

  onCancel() {
    this.modalCtrl.dismiss({
      selectedDays: this.selectedDays
    });
  }

  isSelectAllDays() {
    //   let selectAllDays = false;
    //   for (let i = 0; i < this.lstDays.length; i++) {
    //     if (this.lstDays[i].isChecked === true) {
    //       selectAllDays = true;
    //     } else {
    //       selectAllDays = false;
    //       // return selectAllDays
    //     }
    //   }
    //   console.log('selectAllDays: ', selectAllDays);
    //   return selectAllDays;
    return this.selectAllDays;
  }
}
